import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Card, Button, Spinner, Form } from 'react-bootstrap';
import { FaPlusCircle, FaPlus } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getProduct } from '../../../redux/productSlice';
import { getProductRating } from "../../../redux/reviewSlice";
import { addToCart } from "../../../redux/cartSlice";
// import StarRating from '../../common/StarRating/StarRating';
import ReviewList from '../Review/Review';
import ProductModal from '../../common/ProductModal/ProductModal';
import Star from "../../common/Star/Star";
import { toast } from 'react-toastify';

const ProductDescription = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const dispatch = useDispatch();
  const { id } = useParams();
  const { products, loading, error } = useSelector(state => state.products);
  const product = products.product || {}; // Ensure safe data access
  const [rating, setRating] = useState(0);
  const [image, setImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const values = [true, 'sm-down', 'md-down', 'lg-down', 'xl-down', 'xxl-down'];
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);


  const ratings = useSelector((state) => state.review.ratings);
  console.log("product", product._id);
  console.log("avdhesh", ratings[product._id]);

  useEffect(() => {
    dispatch(getProduct(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (product && product.images && product.images.length > 0) {
      setImage(`${apiUrl}${product.images[0]}`);
    }
  }, [product, apiUrl]);


  const getProductAverageRating = useCallback(async (productId) => {
    try {
      await dispatch(getProductRating(productId));
    } catch (error) {
      console.error("Error fetching product rating:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    getProductAverageRating(product._id);
  }, [getProductAverageRating, product._id]);

  const handleAddToCart = useCallback(async (product) => {
    console.log("product++", product);
    try {

      await dispatch(addToCart({ items: [{ product: product, quantity: 1 }] }));
      toast.success(`${product} added to cart successfully!`);
    } catch {
      toast.error(`Failed to add ${product.name} to cart.`);
    }
  }, [dispatch]);

  if (loading) return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
      <Spinner animation="border" />
    </div>
  );
  if (error) return <h3 className="text-danger">{error}</h3>;


  const getImageUrl = (image, index) => {
    const imageUrl = `${apiUrl}${image}`;
    setImage(imageUrl);
    setSelectedImageIndex(index); // Track selected image
  }
  function handleShow() {
    setShow(true);
  }


  return (
    <Container className="mt-4">
      <Row className="justify-content-center">
        <Col md={1} lg={1}>
          <ul className="list-images">
            {product.images && product.images.map((image, index) => (
              <li key={index}
                className={selectedImageIndex === index ? "active" : ""}
                onClick={() => getImageUrl(image, index)}
              >
                <img
                  src={`${apiUrl}${image}`}
                  alt={`Image ${index + 1}`}
                  className="img-fluid"
                />
              </li>
            ))}
          </ul>
        </Col>
        <Col md={5} lg={5}>
          <Card className="position-relative">
            <FaPlus size={30} onClick={() => handleShow()} className="top-0 mt-2 position-absolute end-0 me-2" />
            <Card.Img
              variant="top"
              src={image || 'placeholder-image-url'}
              alt={product.name || 'Product Image'}
            />
          </Card>
        </Col>
        <Col md={6} lg={6}>
          <Card className="p-3">
            <Card.Body>
              <Card.Title>{product.name}</Card.Title>
              <Card.Text>
                <Star value={product?.averageRating} alignLeft="left" reviewTotalCount={product?.ratings?.length} style={{ fontSize: "24px" }} />
              </Card.Text>
              <Card.Text>{product.description}</Card.Text>
              <h4 className="text-success">Rs. {product.price}</h4>
              <Button variant="primary" className="mt-3" disabled={!product.name} onClick={() => handleAddToCart(product._id)}>
                Add to Cart
              </Button>
            </Card.Body>
          </Card>
          <Card className="p-3">
            <Card.Body>
              <Card.Title>Product Details</Card.Title>
              <Card.Text>
                {product.description}

              </Card.Text>

            </Card.Body>
          </Card>
        </Col>

      </Row>
      <Row>
        <Col lg={12}>
          <ReviewList productId={product?._id} />
        </Col>
      </Row>
      <ProductModal
        handleShow={handleShow}
        values={values}
        product={product}
        fullscreen={fullscreen}
        show={show}
        setShow={setShow}
      />
    </Container>
  );
};

export default ProductDescription;
